import { graphql } from 'gatsby'
import React from 'react'

import Layout from 'components/Layout'
import Meta from 'components/Meta'
import get from 'lodash/get'

const Videos = ({ _, data, location }) => (
  <Layout location={location}>
    <Meta
      site={get(data, 'site.meta')}
      title={'セッション動画'}
      path={`videos`}
    />
    <div id="page-banner-area" className="page-banner-area">
      <div className="page-banner-title">
        <div className="text-center">
          <h2>セッション動画</h2>
          <ol className="breadcrumb">
            <li>Videos</li>
          </ol>
        </div>
      </div>
    </div>
    <section id="main-container" className="main-container ts-gallery">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="aspect">
              <iframe
                width="100%"
                height=""
                src="https://www.youtube.com/embed/videoseries?list=PLVr1RFUUr5ve3Z1VHbpYt8aUFW4UwRIp5"
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  </Layout>
)

export default Videos

export const pageQuery = graphql`
  query VideosMetaQuery {
    site {
      meta: siteMetadata {
        title
        description
        url: siteUrl
        author
        twitter
        adsense
      }
    }
  }
`
